import type { ApiRoute, NoBody, NoQueryParams } from "../../../api"
import type { ListingScoreHintsView } from "./ListingScoreHintsView"

export interface GetListingScoreHintsViewPathParams {
	inventoryId: string
}

export const getListingScoreHintsViewRoute: ApiRoute<
	GetListingScoreHintsViewPathParams,
	NoQueryParams,
	NoBody,
	ListingScoreHintsView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/listing-score-hints`,
	method: "get",
	path: "/vehicles/:inventoryId/listing-score-hints",
}
